import { useQuery } from '@tanstack/react-query';
import { fetchProviderReferrals } from '../api/referralsApi';

/**
 * Hook to fetch existing referrals for a provider
 * Feature 001: FA Dashboard Provider Referrals
 *
 * @param providerId - Service Provider ID
 * @returns Query object with existing referrals
 */
export function useProviderReferrals(providerId: string | null) {
  return useQuery({
    queryKey: ['advisor', 'referrals', 'provider', providerId],
    queryFn: () => {
      if (!providerId) {
        return Promise.resolve([]);
      }
      return fetchProviderReferrals(providerId);
    },
    enabled: !!providerId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
